module.exports = __webpack_public_path__ + "static/media/Guillotine.c1d4ec49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/Guillotine.svg
// module id = 110
// module chunks = 0